// @ts-ignore
// @ts-nocheck
import { AxiosError, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import api from 'services/api';
import { getAccessToken } from './accessTokenServices';

type ErrorData = {
  response: {
    data: {
      message: string;
    };
    status: string;
  };
};

export type NotificationsResponse = {
  id: string;
  title: string;
  body: string;
  url: string;
  userId: string;
  status: string;
  type: string;
  createdAt: string;
};
export const getNotifications = async (): Promise<NotificationsResponse[]> => {
  const access_token = await getAccessToken();
  let notificationsData: NotificationsResponse[] =
    [] as NotificationsResponse[];

  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  const parameters = {
    method: 'GET',
    headers: header,
  } as AxiosRequestConfig;

  try {
    const typeEmp = 'type=EMP';
    const ownerId = localStorage.getItem('@UltragazEmpresarial:customerSiteId');

    const params = ownerId
      ? `?owner-id=${ownerId}&${typeEmp}&status=UNREAD`
      : `?${typeEmp}&status=UNREAD`;

    const response = await api.get(
      `notification/v1/notifications${params}`,
      parameters
    );
    notificationsData = response.data;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  }

  return notificationsData;
};

export const putNotificationsRead = async (
  idNotification: number | string
): Promise<boolean> => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  const parameters = {
    method: 'PATCH',
    headers: header,
  } as AxiosRequestConfig;

  try {
    const body = {
      status: 'READ',
    };

    const response = await api.patch(
      `notification/v1/notifications/${idNotification}`,
      body,
      parameters
    );

    console.log({ response });
    return true;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
    return false;
  }
};
